/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AutomationRun
 */
export interface AutomationRun {
    /**
     * 
     * @type {number}
     * @memberof AutomationRun
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof AutomationRun
     */
    ruleId: number;
    /**
     * 
     * @type {number}
     * @memberof AutomationRun
     */
    companyId: number;
    /**
     * 
     * @type {number}
     * @memberof AutomationRun
     */
    claimId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AutomationRun
     */
    claimNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AutomationRun
     */
    activityEventId: number;
    /**
     * 
     * @type {string}
     * @memberof AutomationRun
     */
    status: AutomationRunStatusEnum;
    /**
     * Why the run was skipped or failed (e.g. NO_RECIPIENT_EMAIL)
     * @type {string}
     * @memberof AutomationRun
     */
    reason?: string | null;
    /**
     * Action output (e.g. formDocumentId for send_form)
     * @type {{ [key: string]: any; }}
     * @memberof AutomationRun
     */
    result?: { [key: string]: any; } | null;
    /**
     * 
     * @type {Date}
     * @memberof AutomationRun
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof AutomationRun
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const AutomationRunStatusEnum = {
    Pending: 'pending',
    Success: 'success',
    Skipped: 'skipped',
    Failed: 'failed'
} as const;
export type AutomationRunStatusEnum = typeof AutomationRunStatusEnum[keyof typeof AutomationRunStatusEnum];


/**
 * Check if a given object implements the AutomationRun interface.
 */
export function instanceOfAutomationRun(value: object): value is AutomationRun {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('ruleId' in value) || value['ruleId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('activityEventId' in value) || value['activityEventId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function AutomationRunFromJSON(json: any): AutomationRun {
    return AutomationRunFromJSONTyped(json, false);
}

export function AutomationRunFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutomationRun {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'ruleId': json['ruleId'],
        'companyId': json['companyId'],
        'claimId': json['claimId'] == null ? undefined : json['claimId'],
        'claimNumber': json['claimNumber'] == null ? undefined : json['claimNumber'],
        'activityEventId': json['activityEventId'],
        'status': json['status'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'result': json['result'] == null ? undefined : json['result'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function AutomationRunToJSON(json: any): AutomationRun {
    return AutomationRunToJSONTyped(json, false);
}

export function AutomationRunToJSONTyped(value?: AutomationRun | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'ruleId': value['ruleId'],
        'companyId': value['companyId'],
        'claimId': value['claimId'],
        'claimNumber': value['claimNumber'],
        'activityEventId': value['activityEventId'],
        'status': value['status'],
        'reason': value['reason'],
        'result': value['result'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
    };
}

